export default {
  namespaced: true,
  state:{    
    contractTypes: [],    
    contractTypeCreate: {
      modal: false,
      values: {}
    },
    contractTypeEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    contractTypes(state){
      return state.contractTypes;
    },   
    contractTypeCreate(state) {
        return state.contractTypeCreate;
    },
    contractTypeEdit(state) {
      return state.contractTypeEdit;
    }    
  },
  mutations:{
    SET_CONTRACT_TYPES(state, values){
      state.contractTypes = values;
    },
    SET_CONTRACT_TYPE_CREATE_MODAL(state, value) {
      state.contractTypeCreate.modal = value;
    },
    SET_CONTRACT_TYPE_CREATE_VALUES(state, value) {
      state.contractTypeCreate.values = value;
    },
    SET_CONTRACT_TYPE_EDIT_MODAL(state, value) {
      state.contractTypeEdit.modal = value;
    },
    SET_CONTRACT_TYPE_EDIT_VALUES(state, value) {
      state.contractTypeEdit.values = value;
    },
    PUSH_CONTRACT_TYPE(state, value){
      state.contractTypes.push(value);
    },    
    SET_UPDATE_CONTRACT_TYPE(state, values){
      var editedIndex = state.contractTypes.map(contractType => contractType.id).indexOf(values.id);      
      if (editedIndex > -1){
        Object.assign(state.contractTypes[editedIndex], values);              
      }
      return;
    },
    SPLICE_CONTRACT_TYPE(state, value){
      let i = state.contractTypes.map(contractType => contractType.id).indexOf(value);      
      state.contractTypes.splice(i, 1);
    }
  },
  actions:{
    getContractTypes({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/contract-types').then((response) => {
          commit('SET_CONTRACT_TYPES', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    contractTypeStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/contract-types', formData).then((response) => {
          commit('PUSH_CONTRACT_TYPE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    contractTypeUpdate({commit}, payload) {
      var value = payload.id;            
      return new Promise((resolve, reject) => {
        axios.put('admin/contract-types/' + value, payload).then((response) => {          
          commit('SET_UPDATE_CONTRACT_TYPE', response.data.data);
          resolve(response);   
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteContractType({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/contract-types/' + value).then((response) => {
          commit('SPLICE_CONTRACT_TYPE', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });      
    },
  }
}
